import api from "./axiosInstance";

// GET all goods
export const getAllGoods = (params) =>
  api.get("goods/getAllGoods", { params });

// CREATE goods
export const saveGoods = (data) =>
  api.post("goods/save", data);

// UPDATE goods
export const updateGoods = (id, data) =>
  api.put(`goods/updateById/${id}`, data);

// DELETE goods
export const deleteGoods = (id) =>
  api.delete(`goods/deleteById/${id}`);

// EXPORT goods to Excel
export const exportGoods = () =>
  api.get("goods/export", {
    responseType: "blob",
  }).then(response => response);

// IMPORT goods from Excel
export const importGoods = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return api.post("goods/import", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};